/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/

const getters = {
  getAllAlert: (state) => () => {
    let tmp = JSON.parse(JSON.stringify(state.notifData))
    return tmp.reverse()
  },
  getHundredAlert: (state) => () => {
    let tmp = JSON.parse(JSON.stringify(state.notifData))
    return tmp.slice(0, 100)
  },
  getCounter: (state) => () => {
    // Count only unread notifications
    const unreadCount = state.notifData.filter(notif => !notif.is_read).length
    return unreadCount
  },

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
}

export default getters
